import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { reactive } from 'vue';
import { isLoggedIn } from './auth';
import 'bootswatch/dist/darkly/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

router.beforeEach((to, from, next) => {
  const needAuth = to.matched.some(record => record.meta.requiresAuth);
  if (needAuth && !isLoggedIn()) {
    next({ path: '/', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

const app = createApp(App).use(router)

app.config.globalProperties.$USER = reactive({
  secretId: localStorage.getItem('rtcrobotsecretid'),
  secretKey: localStorage.getItem('rtcrobotsecretkey'),
  roomId: localStorage.getItem('rtcrobotroomid'),
  role: localStorage.getItem('rtcrobotrole'),
});

app.config.globalProperties.$APP_ID = '3b64a6f5683d4abe9a7f3f72b7e7e9c8'
app.mount('#app')
